module.exports = __webpack_public_path__ + "static/media/esports.324272df.svg";